import { Form, Row } from 'antd';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { SVGS } from '~/assets/assetsPath';
import config from '~/config';
import styles from './FormSuccessChangePass.module.scss';

const cx = classNames.bind(styles);

const SuccessChangePassModal = () => {
    const navigate = useNavigate();
    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Password changed successfully
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center">
                    <img src={SVGS.IconChangePassSuccess} alt="" />
                </Row>
            </Form.Item>
            <Form.Item style={{ marginTop: '40px' }}>
                <div htmlType="submit" className={cx('btn_login')} onClick={() => navigate(config.routes.home)}>
                    On the homepage
                </div>
            </Form.Item>
        </Form>
    );
};

export default SuccessChangePassModal;
